import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/settlements';

const namespace = 'SETTLEMENTS';

export const FETCH_SETTLEMENTS_START = `${namespace}/FETCH_SETTLEMENTS_START`;
export const FETCH_SETTLEMENTS_SUCCESS = `${namespace}/FETCH_SETTLEMENTS_SUCCESS`;
export const FETCH_SETTLEMENTS_ERROR = `${namespace}/FETCH_SETTLEMENTS_ERROR`;

export const fetchSettlements = makeApiActionCreatorV3(
  api.fetchSettlements,
  FETCH_SETTLEMENTS_START,
  FETCH_SETTLEMENTS_SUCCESS,
  FETCH_SETTLEMENTS_ERROR,
);

export const FETCH_SETTLEMENT_START = `${namespace}/FETCH_SETTLEMENT_START`;
export const FETCH_SETTLEMENT_SUCCESS = `${namespace}/FETCH_SETTLEMENT_SUCCESS`;
export const FETCH_SETTLEMENT_ERROR = `${namespace}/FETCH_SETTLEMENT_ERROR`;

export const fetchSettlement = makeApiActionCreatorV3(
  api.fetchSettlement,
  FETCH_SETTLEMENT_START,
  FETCH_SETTLEMENT_SUCCESS,
  FETCH_SETTLEMENT_ERROR,
);

export const INSERT_SETTLEMENT_START = `${namespace}/INSERT_SETTLEMENT_START`;
export const INSERT_SETTLEMENT_SUCCESS = `${namespace}/INSERT_SETTLEMENT_SUCCESS`;
export const INSERT_SETTLEMENT_ERROR = `${namespace}/INSERT_SETTLEMENT_ERROR`;

export const insertSettlement = makeApiActionCreatorV3(
  api.insertSettlement,
  INSERT_SETTLEMENT_START,
  INSERT_SETTLEMENT_SUCCESS,
  INSERT_SETTLEMENT_ERROR,
);

export const UPDATE_SETTLEMENT_START = `${namespace}/UPDATE_SETTLEMENT_START`;
export const UPDATE_SETTLEMENT_SUCCESS = `${namespace}/UPDATE_SETTLEMENT_SUCCESS`;
export const UPDATE_SETTLEMENT_ERROR = `${namespace}/UPDATE_SETTLEMENT_ERROR`;

export const updateSettlement = makeApiActionCreatorV3(
  api.updateSettlement,
  UPDATE_SETTLEMENT_START,
  UPDATE_SETTLEMENT_SUCCESS,
  UPDATE_SETTLEMENT_ERROR,
);

export const UPDATE_SETTLEMENT_TAGS_START = `${namespace}/UPDATE_SETTLEMENT_TAGS_START`;
export const UPDATE_SETTLEMENT_TAGS_SUCCESS = `${namespace}/UPDATE_SETTLEMENT_TAGS_SUCCESS`;
export const UPDATE_SETTLEMENT_TAGS_ERROR = `${namespace}/UPDATE_SETTLEMENT_TAGS_ERROR`;

export const updateSettlementTags = makeApiActionCreatorV3(
  api.updateSettlementTags,
  UPDATE_SETTLEMENT_TAGS_START,
  UPDATE_SETTLEMENT_TAGS_SUCCESS,
  UPDATE_SETTLEMENT_TAGS_ERROR,
);

export const DELETE_SETTLEMENT_START = `${namespace}/DELETE_SETTLEMENT_START`;
export const DELETE_SETTLEMENT_SUCCESS = `${namespace}/DELETE_SETTLEMENT_SUCCESS`;
export const DELETE_SETTLEMENT_ERROR = `${namespace}/DELETE_SETTLEMENT_ERROR`;

export const deleteSettlement = makeApiActionCreatorV3(
  api.deleteSettlement,
  DELETE_SETTLEMENT_START,
  DELETE_SETTLEMENT_SUCCESS,
  DELETE_SETTLEMENT_ERROR,
);
